import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField as Input,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import {
  Menu as MenuIcon,
  ExitToApp as ExitToAppIcon,
  ArrowBack as ArrowBackIcon,
  Lock as LockIcon,
  PersonOutlineOutlined as PersonOutlineOutlinedIcon 
} from "@material-ui/icons";
import classNames from "classnames";
import joi from 'joi-browser';

// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers/Wrappers";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar
} from "../../context/LayoutContext";
import { useUserAuthDispatch, signOut } from "../../context/UserAuthContext";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { apiCall, displayLog, validate } from "../../common/common";

import alertify from 'alertifyjs';
import 'alertifyjs/build/css/themes/default.min.css';
import 'alertifyjs/build/css/alertify.min.css';

import showeye from "../../static/images/images/eye-show-icon.svg"
import hideEye from "../../static/images/images/eye-hide-icon.svg"
import "../../static/css/global.css"



export default function Header(props) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserAuthDispatch();

  // local
  var [profileMenu, setProfileMenu] = useState(null);
  const [isSmall, setSmall] = useState(false);
  const [toggleInputModal, setToggleInputModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorField, setErrorField] = useState(null);
  const [formValues, setFormValues] = useState({});

  const [currentPassword, setcurrentpassword] = useState(false);
  const [newPassword, setnewpassword] = useState(false);
  const [confirmPassword, setconfirmpassword] = useState(false);

  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;
    setSmall(isSmallScreen);
  }

  //Function call when user wants to logout
  const logoutHandler = (e, userDispatch, history) => {
    e.preventDefault();
    alertify.confirm("Are you sure you want to logout?", (status) => {
      if (status) {
        signOut(userDispatch, history)
      }
    }).setHeader('<em>Tangeebl</em> ').set('labels', { ok: 'OK', cancel: 'CANCEL' });
  }

  //Function to close change password modal
  const closeModal = () => {
    setError('')
    setErrorField('')
    setFormValues({})
    setProfileMenu(null)
    setToggleInputModal(false)
  }

  //Function calls on submit form
  const submitChangePasswordHandler = () => {
    let reqData = {
      old_password: formValues.current_password,
      new_password: formValues.new_password,
      confirm_password: formValues.confirm_password,
    }
    validateFormData(reqData);
  }

  //Function to validate form data
  const validateFormData = (body) => {
    let schema = joi.object().keys({
      old_password: joi.string().trim().min(8).required(),
      new_password: joi.string().trim().min(8).required(),
      confirm_password: joi.string().trim().valid(joi.ref('new_password')).required(),
    })
    joi.validate(body, schema, async (err, value) => {
      if (err) {
        if (err.details[0].message !== error || error.details[0].context.key !== errorField) {
          let errorLog = validate(err)
          setError(errorLog.error)
          setErrorField(errorLog.errorField)
        }
      }
      else {
        setIsLoading(true)
        let reqData = {
          old_password: formValues.current_password,
          new_password: formValues.new_password
        }
        let res = await apiCall('POST', '', '/admin/changePassword', reqData)
        if (res.data) {
          if (res.data.code === 0) {
            displayLog(0, res.data.message)
          } else {
            displayLog(1, res.data.message)
          }
        }
        closeModal()
        setIsLoading(false)
      }
    })
  }


  const togglepassword = () => {
    setcurrentpassword(!currentPassword);
  }

  const newPass =()=>{
    setnewpassword(!newPassword)
  }

  const confirmPass = ()=>{
    setconfirmpassword(!confirmPassword)
  }


  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse
          )}
        >
          {(!layoutState.isSidebarOpened && isSmall) ||
            (layoutState.isSidebarOpened && !isSmall) ? (
              <ArrowBackIcon
                classes={{
                  root: classNames(classes.headerIcon, classes.headerIconCollapse)
                }}
              />
            ) : (
              <MenuIcon
                classes={{
                  root: classNames(classes.headerIcon, classes.headerIconCollapse)
                }}
              />
            )}
        </IconButton>
        <Typography variant="h6" weight="medium" className={classes.logotype}>
          Tangeebl
        </Typography>
        <div className={classes.grow} />
        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
           <PersonOutlineOutlinedIcon className={classes.adminProfileIcon} />
        </IconButton>
        <Typography
          block
          variant="body2"
          style={{ display: "flex", alignItems: "center", marginLeft: 4, color:'#FFFFFF' }}
        >
          Hi,&nbsp;
          <Typography variant="body2" weight={"bold"}>
            Admin
          </Typography>
        </Typography>
        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem
            )}
            onClick={() => setToggleInputModal(true)}
          >
            <LockIcon className={classes.profileMenuIcon} /> Change Password
          </MenuItem>
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem
            )}
            onClick={(e) => logoutHandler(e, userDispatch, props.history)}
          >
            <ExitToAppIcon className={classes.profileMenuIcon} /> Sign Out
          </MenuItem>
        </Menu>
      </Toolbar>
      <Dialog
        open={toggleInputModal}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
        <DialogContent>

        <div className="inputIcon">
          <Input
            // label='Current Password'
            placeholder={"Current Password"}
            margin="normal"
            variant="outlined"
            onChange={e => setFormValues({ ...formValues, current_password: e.target.value.replace(/^\s+/, "") })}
            InputProps={{
              classes: {
                underline: classes.InputUnderline,
                input: classes.Input
              }
            }}
            type={currentPassword == true ? "text" : "Password"}
            value={formValues.current_password}
            fullWidth
          />
          
          {errorField === 'current_password' && <ErrorMessage error={error} />}
          <img src={currentPassword == true ? showeye : hideEye} alt="" onClick={togglepassword} />
          </div>

          <div className="inputIcon">
          <Input
            // label='New Password'
            placeholder={"New Password"}
            margin="normal"
            variant="outlined"
            onChange={e => setFormValues({ ...formValues, new_password: e.target.value.replace(/^\s+/, "") })}
            InputProps={{
              classes: {
                underline: classes.InputUnderline,
                input: classes.Input
              }
            }}
            type={newPassword == true ? "text" : "Password"}
            value={formValues.new_password}
            fullWidth
          />
          {errorField === 'new_password' && <ErrorMessage error={error} />}
          <img src={newPassword == true ? showeye : hideEye} alt="" onClick={newPass} />
          </div>

          <div className="inputIcon">
          <Input
            // label='Confirm Password'
            placeholder={"Confirm Password"}
            margin="normal"
            variant="outlined"
            onChange={e => setFormValues({ ...formValues, confirm_password: e.target.value.replace(/^\s+/, "") })}
            InputProps={{
              classes: {
                underline: classes.InputUnderline,
                input: classes.Input
              }
            }}
            type={confirmPassword == true ? "text" : "Password"}
            value={formValues.confirm_password}
            fullWidth
          />
          {errorField === 'confirm_password' && <ErrorMessage error={error} />}
          <img src={confirmPassword == true ? showeye : hideEye} alt="" onClick={confirmPass} />
          </div>

          
        </DialogContent>
        <DialogActions style={{ padding: "10px 24px 20px" }}>
          <Button
            variant={"outlined"}
            color="primary"
            onClick={closeModal}
            disabled={isLoading}
          >Cancel</Button>
          <Button
            variant={"contained"}
            color="primary"
            onClick={submitChangePasswordHandler}
            disabled={isLoading}
          >Submit</Button>
        </DialogActions>
      </Dialog>

    </AppBar>
  );
}
